<div class="mt-4">
    <form [formGroup]="merchantIssueForm" (ngSubmit)="onSubmit()">
        <div class="card">
            <!-- <div class="card-header"> -->
            <!-- <h4>Create Support Ticket</h4> -->
            <!-- </div> -->
            <div class="card-body">
                <!-- Title Input -->
                <div class="form-group row mb-3">
                    <label for="title" class="col-sm-2 col-form-label">Title*</label>
                    <div class="col-sm-5">
                        <input type="text" id="title" class="form-control" placeholder="Enter issue title"
                            formControlName="title">
                            <div class="form-text text-danger" *ngIf="!merchantIssueForm.get('title').valid && merchantIssueForm.get('title').touched">
                                {{ 'Please provide a valid Title' | translate | async }}
                              </div>
                    </div>
                </div>

                <!-- Description Input -->
                <!-- <div class="form-group row mb-3">
                    <label for="description" class="col-sm-2 col-form-label">Description*</label>
                    <div class="col-sm-5">
                        <textarea id="description" class="form-control" rows="5" placeholder="Describe the issue"
                            formControlName="description"></textarea>
                    </div>
                </div> -->
                <!-- CKEditor for Adding Comments -->
                <div class="form-group row mb-3">
                    <label for="commentText" class="col-sm-2 col-form-label">Description*</label>
                    <div class="col-sm-5">
                        <ckeditor [editor]="Editor" formControlName="description" [config]="{
                           placeholder: 'Please Describe the Issue...',
                           toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'blockQuote', '|', 'undo', 'redo']
                          }"></ckeditor>
                    </div>
                </div>

                <!-- File Upload for Attachments -->
                <div class="form-group row mb-3">
                    <label class="col-sm-2 col-form-label">Attachments <i class="f-10 fas fa-info-circle vertical-align-super" #popoverTriggerName="ngbPopover"
                        [ngbPopover]="'Attachment Allowd Max Size 5 MB.' | translate | async"
                        triggers="mouseenter:mouseleave" [popoverTitle]="'Attachment' | translate | async" placement="right"></i></label>
                    <div class="col-sm-5">
                        <ngx-dropzone (change)="onFilesAdded($event)" [accept]="'image/*,video/*,audio/*,.xls,.xlsx'"
                            multiple>
                            <ngx-dropzone-label>
                                <div class="d-flex flex-column justify-content-center align-items-center">
                                    <img src="../../../../assets/images/uplode-menu.png" class="mb-3"
                                        style="width: 50px" />
                                    <div class="fs-6 text-dark fw-bold">
                                        <p class="mb-0 fw-500">{{ "Drop files here or click to upload" | translate |
                                            async }}</p>
                                    </div>
                                </div>
                            </ngx-dropzone-label>
                            <ngx-dropzone-preview *ngFor="let f of files" [removable]="true"
                                (removed)="onRemoveFile(f)">
                                <ngx-dropzone-label>{{ f.file.name }}</ngx-dropzone-label>
                                <small class="text-muted">{{ f.uploadTime | date:'short' }}</small>
                            </ngx-dropzone-preview>
                        </ngx-dropzone>
                    </div>
                </div>

                <!-- CKEditor for Adding Comments -->
                <!-- <div class="form-group row mb-3">
                    <label for="commentText" class="col-sm-2 col-form-label">Comments</label>
                    <div class="col-sm-5">
                        <ckeditor [editor]="Editor" formControlName="commentText" [config]="{
                            placeholder: 'Please Describe the Issue...',
                            toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'blockQuote', '|', 'undo', 'redo']
                          }"></ckeditor>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="form-btn">
            <div class="btn-main">
                <div>
                    <button class="cancel-btn me-3" (click)="goBack()">{{ "Cancel" | translate | async }}</button>
                </div>
                <div>
                    <button class="save-btn" *ngIf="!isLoading" (click)="onSubmit()" type="button" [disabled]="!merchantIssueForm.valid">
                        {{ "Save" | translate | async }}
                    </button>
                   <button class="save-btn" disabled *ngIf="isLoading">
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="pl-2">&nbsp;&nbsp;{{ "Save" | translate | async }}</span>
                </button>
                </div>
            </div>
        </div>
    </form>
</div>